import { render, staticRenderFns } from "./LogSummary.vue?vue&type=template&id=d2b2fa32&scoped=true&"
import script from "./LogSummary.vue?vue&type=script&lang=js&"
export * from "./LogSummary.vue?vue&type=script&lang=js&"
import style0 from "./LogSummary.vue?vue&type=style&index=0&id=d2b2fa32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b2fa32",
  null
  
)

export default component.exports